import React, { useState } from 'react';

import {
  Link,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from 'components';
import { useIsMobile } from 'hooks';
import { ExportSquare } from 'iconsax-react';

import { useLocation } from 'third-party';

import { NavigationItems } from 'types/app';

type Props = {
  item: NavigationItems;
  isCollapsed: boolean;
};

export const NavigationLink: React.FC<Props> = ({ item, isCollapsed }) => {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const [isHovered, setIsHovered] = useState(false);

  if (item.component) {
    return item.component;
  }

  return (
    <div id={item.id}>
      <Link
        href={item.url?.() || '#'}
        underline="none"
        target={item.openInNewTab ? '_blank' : undefined}
        rel={item.openInNewTab ? 'noopener noreferrer' : undefined}
      >
        <ListItem disablePadding>
          <Tooltip
            disableInteractive={!isCollapsed}
            disableHoverListener={!isCollapsed}
            disableFocusListener={!isCollapsed}
            title={
              <Typography
                variant="body2"
                sx={{
                  fontSize: isMobile ? '0.9rem' : undefined,
                  display: 'flex',
                  textTransform: 'capitalize',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                {item.text}
                {item.openInNewTab && (
                  <ExportSquare
                    variant="TwoTone"
                    size="0.9rem"
                    style={{
                      marginLeft: '0.5rem',
                    }}
                  />
                )}
              </Typography>
            }
            placement="right"
            arrow
          >
            <ListItemButton
              selected={pathname == item.url?.()}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              sx={{
                padding: isMobile ? '0.5rem 0.75rem' : undefined,
                borderRadius: isMobile ? '8px' : undefined,
                ...(!isMobile && {
                  borderLeft: '2px solid transparent',
                  ...(pathname === item.url?.() && {
                    borderLeftColor: 'rgba(255,255,255,0.9)',
                  }),
                }),
              }}
            >
              {item.icon && (
                <ListItemIcon
                  sx={{
                    color:
                      pathname == item.url?.() ? 'primary.main' : undefined,
                  }}
                >
                  {item.icon}
                </ListItemIcon>
              )}
              {!isCollapsed && (
                <ListItemText
                  primary={
                    <span
                      style={{
                        textTransform: 'capitalize',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                      }}
                    >
                      <span>{item.text}</span>
                      {item.openInNewTab && isHovered && (
                        <ExportSquare
                          variant="TwoTone"
                          size="0.9rem"
                          style={{
                            marginLeft: 'auto',
                          }}
                        />
                      )}
                    </span>
                  }
                  primaryTypographyProps={{
                    fontSize: isMobile ? '0.9rem' : undefined,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    display: 'block',
                  }}
                />
              )}
            </ListItemButton>
          </Tooltip>
        </ListItem>
      </Link>
    </div>
  );
};
